import React from 'react'
import { useTranslation } from 'react-i18next'
import { motion, useInView } from 'framer-motion'
import Typography from '~/components/Typography'
import { parseSafeArrayStrings } from '~/helpers/string'

const Word = ({ word }: { word: string }) => {
  const ref = React.useRef<HTMLSpanElement>(null)
  const isInView = useInView(ref, {
    margin: `50% 0px -50% 0px`
  })

  return (
    <motion.span
      ref={ref}
      initial={{ opacity: 0.2 }}
      animate={{ opacity: isInView ? 1 : 0.2 }}
      transition={{
        duration: 0.3
      }}
    >
      {word}{' '}
    </motion.span>
  )
}

const Manifest = () => {
  const { t } = useTranslation()

  const paragraphsSplittedByWords = React.useMemo(() => {
    return parseSafeArrayStrings(
      t('manifesto:paragraphs', {
        returnObjects: true
      }),
      (paragraphs) => {
        return paragraphs.map((paragraph) => {
          return paragraph.split(' ')
        })
      }
    )
  }, [t])

  return paragraphsSplittedByWords.map((paragraph, paragraphIndex) => {
    return (
      <Typography
        className="text-4xl leading-[1.3em] max-md:text-2xl max-sm:text-xl"
        // eslint-disable-next-line react/no-array-index-key
        key={paragraphIndex}
      >
        {paragraph.map((word, wordIndex) => {
          return (
            <Word
              // eslint-disable-next-line react/no-array-index-key
              key={wordIndex}
              word={word}
            />
          )
        })}
      </Typography>
    )
  })
}

export default Manifest
